import Link from 'next/link';
import { Button } from '@savvy-kit/components/button';
import { ArrowUpRight } from 'lucide-react';

export function MarketingEmailHubCard() {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#F9FAFB] to-[#EDE8DC] dark:from-card dark:to-muted">
      <div
        className="absolute inset-0 mix-blend-soft-light opacity-10 dark:hidden pointer-events-none"
        style={{
          backgroundImage: "url('/marketing/hero-texture.png')",
          backgroundSize: 'cover',
        }}
      />
      <div className="relative flex items-center justify-between gap-6 px-6 py-5">
        <div className="min-w-0">
          <h3 className="text-base font-semibold tracking-tight text-foreground">Send emails that actually land.</h3>
          <p className="mt-1 text-sm text-secondary leading-snug">
            Get access to Constant Contact and follow our deliverability playbook to keep your sender reputation strong.
          </p>
        </div>
        <Button
          variant="secondary"
          size="sm"
          className="shrink-0"
          render={
            <Link
              href="https://savvy-email-marketing-hub.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open email hub in a new tab"
            />
          }
        >
          Open email hub <ArrowUpRight className="size-3.5" />
        </Button>
      </div>
    </div>
  );
}
